var map = {
	"./amex.svg": 17804,
	"./cabal.svg": 69786,
	"./check.svg": 69823,
	"./error.svg": 1321,
	"./maestro.svg": 58204,
	"./mastercard.svg": 28929,
	"./mp_logo.svg": 30148,
	"./pos_externo.svg": 96721,
	"./visa-credito.svg": 63199,
	"./visa-debito.svg": 75454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71445;